import { Box, Typography, Chip } from "@mui/material";
import { DelegationTask } from "protogen/delegations_pb";
import { Zap } from "lucide-react";
import FlexBox from "components/common/FlexBox";
import useIsMobile from "components/hooks/useIsMobile";

interface DelegationStatusBannerProps {
  delegationTasks: DelegationTask[];
}

const DelegationStatusBanner = ({
  delegationTasks,
}: DelegationStatusBannerProps) => {
  const isMobile = useIsMobile();
  const activeDelegations = delegationTasks.filter(
    (dt) =>
      dt.status === "in_progress" ||
      dt.status === "delegated" ||
      dt.status === "queued",
  );

  if (activeDelegations.length === 0) {
    return null;
  }

  const inProgressCount = activeDelegations.filter(
    (dt) => dt.status === "in_progress" || dt.status === "delegated",
  ).length;
  const queuedCount = activeDelegations.filter(
    (dt) => dt.status === "queued",
  ).length;

  return (
    <Box
      sx={{
        position: "sticky",
        top: isMobile ? "50px" : 0,
        zIndex: 100,
        display: "flex",
        alignItems: isMobile ? "start" : "center",
        flexDirection: isMobile ? "column" : "row",
        gap: "12px",
        padding: isMobile ? "16px" : "16px 24px",
        backgroundColor: "#F2F8F8",
        borderRadius: "12px",
        border: "1px solid #D4D4D4",
        marginBottom: "12px",
      }}
    >
      <FlexBox alignItems="center" gap="12px" sx={{ flex: 1 }}>
        <Box
          sx={{
            backgroundColor: "#E6F4F4",
            borderRadius: "8px",
            padding: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Zap size={20} color="#198282" fill="#198282" />
        </Box>
        <FlexBox direction="column" gap="4px">
          <Typography variant="bodyHeavy" sx={{ color: "#198282" }}>
            Lightning Tasks Active
          </Typography>
          <FlexBox gap="8px" alignItems="center">
            {inProgressCount > 0 && (
              <Chip
                label={`${inProgressCount} in progress`}
                variant="warning"
                size="small"
                sx={{ height: "20px", fontSize: "11px" }}
              />
            )}
            {queuedCount > 0 && (
              <Chip
                label={`${queuedCount} queued`}
                variant="gray"
                size="small"
                sx={{ height: "20px", fontSize: "11px" }}
              />
            )}
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </Box>
  );
};

export default DelegationStatusBanner;
